// extracted by mini-css-extract-plugin
module.exports = {"search-box":"Q_fF","search-box__input":"Q_fG form-control","search-box__icon":"Q_fH ml-2"};